import { render, staticRenderFns } from "./IAM05.vue?vue&type=template&id=17e8e350"
import script from "./IAM05.vue?vue&type=script&lang=js"
export * from "./IAM05.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports